import { render, staticRenderFns } from "./CompanyListTable.vue?vue&type=template&id=ccb66ab6&scoped=true&"
import script from "./CompanyListTable.vue?vue&type=script&lang=js&"
export * from "./CompanyListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb66ab6",
  null
  
)

export default component.exports